export function checkCanPauseAutomation(bill) {
  return [2].includes(bill.provider_bill_type);
}

export function checkCanSplitBill(bill) {
  return [2].includes(bill.provider_bill_type);
}
